import { pgEnum } from "drizzle-orm/pg-core";
import z from "zod";

export const orderByDirectionSchema = z.enum(["ASC", "DESC"]);
export type OrderByDirectionType = z.infer<typeof orderByDirectionSchema>;

// US States Enum
export const usStatesEnumSchema = z.enum([
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
]);
export type UsStatesEnumType = z.infer<typeof usStatesEnumSchema>;
export const usStatesEnum = pgEnum("us_states_enum", usStatesEnumSchema.enum);

// Pregnant Status Enum
export const pregnantStatusEnumSchema = z.enum(["PREGNANT", "NOT_PREGNANT"]);
export type PregnantStatusEnumType = z.infer<typeof pregnantStatusEnumSchema>;
export const pregnantStatusEnum = pgEnum(
  "pregnant_status_enum",
  pregnantStatusEnumSchema.enum,
);

// Breast Cancer Status Enum
export const breastCancerStatusEnumSchema = z.enum([
  "BREAST_CANCER",
  "NOT_BREAST_CANCER",
]);
export type BreastCancerStatusEnumType = z.infer<
  typeof breastCancerStatusEnumSchema
>;
export const breastCancerStatusEnum = pgEnum(
  "breast_cancer_status_enum",
  breastCancerStatusEnumSchema.enum,
);

// Cervical Cancer Status Enum
export const cervicalCancerStatusEnumSchema = z.enum([
  "CERVICAL_CANCER",
  "NOT_CERVICAL_CANCER",
]);
export type CervicalCancerStatusEnumType = z.infer<
  typeof cervicalCancerStatusEnumSchema
>;
export const cervicalCancerStatusEnum = pgEnum(
  "cervical_cancer_status_enum",
  cervicalCancerStatusEnumSchema.enum,
);

// Disabled Status Enum
export const disabledStatusEnumSchema = z.enum(["DISABLED", "NOT_DISABLED"]);
export type DisabledStatusEnumType = z.infer<typeof disabledStatusEnumSchema>;
export const disabledStatusEnum = pgEnum(
  "disabled_status_enum",
  disabledStatusEnumSchema.enum,
);

// Blind or Vision Loss Status Enum
export const blindOrVisionLossStatusEnumSchema = z.enum([
  "BLIND_OR_VISION_LOSS",
  "NOT_BLIND_OR_VISION_LOSS",
]);
export type BlindOrVisionLossStatusEnumType = z.infer<
  typeof blindOrVisionLossStatusEnumSchema
>;
export const blindOrVisionLossStatusEnum = pgEnum(
  "blind_or_vision_loss_status_enum",
  blindOrVisionLossStatusEnumSchema.enum,
);

// Foster Care Formerly Status Enum
export const fosterCareFormerlyStatusEnumSchema = z.enum([
  "FORMER_FOSTER",
  "NOT_FORMER_FOSTER",
]);
export type FosterCareFormerlyStatusEnumType = z.infer<
  typeof fosterCareFormerlyStatusEnumSchema
>;
export const fosterCareFormerlyStatusEnum = pgEnum(
  "foster_care_formerly_status_enum",
  fosterCareFormerlyStatusEnumSchema.enum,
);

// Marital Status Enum
export const maritalStatusEnumSchema = z.enum([
  "NEVER_MARRIED",
  "MARRIED",
  "SEPARATED",
  "DIVORCED",
  "WIDOWED",
  "REGISTERED_DOMESTIC_PARTNER",
  "COMMON_LAW",
]);
export type MaritalStatusEnumType = z.infer<typeof maritalStatusEnumSchema>;
export const maritalStatusEnum = pgEnum(
  "marital_status_enum",
  maritalStatusEnumSchema.enum,
);

// Child Caregiver Status Enum
export const childCaregiverStatusEnumSchema = z.enum([
  "CAREGIVER",
  "NOT_CAREGIVER",
]);
export type ChildCaregiverStatusEnumType = z.infer<
  typeof childCaregiverStatusEnumSchema
>;
export const childCaregiverStatusEnum = pgEnum(
  "child_caregiver_status_enum",
  childCaregiverStatusEnumSchema.enum,
);

// Needs Help Daily Activities Status Enum
export const needsHelpDailyActivitiesStatusEnumSchema = z.enum([
  "DAILY_HELP_NEEDED",
  "NO_DAILY_HELP_NEEDED",
]);
export type NeedsHelpDailyActivitiesStatusEnumType = z.infer<
  typeof needsHelpDailyActivitiesStatusEnumSchema
>;
export const needsHelpDailyActivitiesStatusEnum = pgEnum(
  "needs_help_daily_activities_status_enum",
  needsHelpDailyActivitiesStatusEnumSchema.enum,
);

// Veteran or Military Member Status Enum
export const veteranOrMilitaryMemberStatusEnumSchema = z.enum([
  "VETERAN_OR_MILITARY_MEMBER",
  "NOT_VETERAN_OR_MILITARY_MEMBER",
]);
export type VeteranOrMilitaryMemberStatusEnumType = z.infer<
  typeof veteranOrMilitaryMemberStatusEnumSchema
>;
export const veteranOrMilitaryMemberStatusEnum = pgEnum(
  "veteran_or_military_member_status_enum",
  veteranOrMilitaryMemberStatusEnumSchema.enum,
);

// American Indian or Alaska Native Status Enum
export const americanIndianOrAlaskaNativeStatusEnumSchema = z.enum([
  "AMERICAN_INDIAN_OR_ALASKA_NATIVE",
  "NOT_AMERICAN_INDIAN_OR_ALASKA_NATIVE",
]);
export type AmericanIndianOrAlaskaNativeStatusEnumType = z.infer<
  typeof americanIndianOrAlaskaNativeStatusEnumSchema
>;
export const americanIndianOrAlaskaNativeStatusEnum = pgEnum(
  "american_indian_or_alaska_native_status_enum",
  americanIndianOrAlaskaNativeStatusEnumSchema.enum,
);

// Student Full Time 18 - 20 Status Enum
export const studentFullTime18to20StatusEnumSchema = z.enum([
  "STUDENT",
  "NOT_STUDENT",
]);
export type StudentFullTime18to20StatusEnumType = z.infer<
  typeof studentFullTime18to20StatusEnumSchema
>;
export const studentFullTime18to20StatusEnum = pgEnum(
  "student_full_time_18_to_20_status_enum",
  studentFullTime18to20StatusEnumSchema.enum,
);

// Medical Expenses 3 Months Help Needed Status Enum
export const medicalExpenses3MonthsHelpNeededStatusEnumSchema = z.enum([
  "MEDICAL_EXPENSES",
  "NO_MEDICAL_EXPENSES",
]);
export type MedicalExpenses3MonthsHelpNeededStatusEnumType = z.infer<
  typeof medicalExpenses3MonthsHelpNeededStatusEnumSchema
>;
export const medicalExpenses3MonthsHelpNeededStatusEnum = pgEnum(
  "medical_expenses_3_months_help_needed_status_enum",
  medicalExpenses3MonthsHelpNeededStatusEnumSchema.enum,
);

// Tobacco Status Enum
export const tobaccoStatusEnumSchema = z.enum([
  "TOBACCO_USED",
  "NO_TOBACCO_USED",
]);
export type TobaccoStatusEnumType = z.infer<typeof tobaccoStatusEnumSchema>;
export const tobaccoStatusEnum = pgEnum(
  "tobacco_status_enum",
  tobaccoStatusEnumSchema.enum,
);

// Citizenship Status Enum
export const citizenshipStatusEnumSchema = z.enum([
  "US_CITIZEN",
  "US_NATIONAL",
  "IMMIGRANT",
  "NOT_ANSWERED",
]);
export type CitizenshipStatusEnumType = z.infer<
  typeof citizenshipStatusEnumSchema
>;
export const citizenshipStatusEnum = pgEnum(
  "citizenship_status_enum",
  citizenshipStatusEnumSchema.enum,
);

// Health Insurance or Coverage Status Enum
export const healthInsuranceOrCoverageStatusEnumSchema = z.enum([
  "MEDICARE",
  "MEDICAID",
  "EMPLOYER",
  "TRICARE",
  "VA",
  "PRIVATE",
  "NOT_COVERED",
  "OTHER",
]);
export type HealthInsuranceOrCoverageStatusEnumType = z.infer<
  typeof healthInsuranceOrCoverageStatusEnumSchema
>;
export const healthInsuranceOrCoverageStatusEnum = pgEnum(
  "health_insurance_or_coverage_status_enum",
  healthInsuranceOrCoverageStatusEnumSchema.enum,
);

// Medicare Plan Type Enum
export const medicarePlanTypeEnumSchema = z.enum([
  "ORIGINAL",
  "ADVANTAGE",
  "NOT_SURE",
]);
export type MedicarePlanTypeEnumType = z.infer<
  typeof medicarePlanTypeEnumSchema
>;
export const medicarePlanTypeEnum = pgEnum(
  "medicare_plan_type_enum",
  medicarePlanTypeEnumSchema.enum,
);

// Tax Filling Status Enum
export const taxFilingStatusEnumSchema = z.enum([
  "SINGLE",
  "HEAD",
  "JOINTLY",
  "SEPARATELY",
  "WIDOWER",
  "NON_FILER",
]);
export type TaxFilingStatusEnumType = z.infer<typeof taxFilingStatusEnumSchema>;
export const taxFilingStatusEnum = pgEnum(
  "tax_filing_status_enum",
  taxFilingStatusEnumSchema.enum,
);

// Tax Dependents Claimed Status Enum
export const taxDependentsClaimedStatusEnumSchema = z.enum([
  "CLAIMED",
  "NOT_CLAIMED",
]);
export type TaxDependentsClaimedStatusEnumType = z.infer<
  typeof taxDependentsClaimedStatusEnumSchema
>;
export const taxDependentsClaimedStatusEnum = pgEnum(
  "tax_dependents_claimed_status_enum",
  taxDependentsClaimedStatusEnumSchema.enum,
);

// Tax Claimed as Dependent Status Enum
export const taxClaimedAsDependentStatusEnumSchema = z.enum([
  "CLAIMED_AS_DEPENDENT",
  "NOT_CLAIMED_AS_DEPENDENT",
]);
export type TaxClaimedAsDependentStatusEnumType = z.infer<
  typeof taxClaimedAsDependentStatusEnumSchema
>;
export const taxClaimedAsDependentStatusEnum = pgEnum(
  "tax_claimed_as_dependent_status_enum",
  taxClaimedAsDependentStatusEnumSchema.enum,
);

// Eployment Status Enum - EMPLOYED, UNEMPLOYED, SELF_EMPLOYED
export const employmentStatusEnumSchema = z.enum([
  "EMPLOYED",
  "UNEMPLOYED",
  "SELF_EMPLOYED",
]);
export type EmploymentStatusEnumType = z.infer<
  typeof employmentStatusEnumSchema
>;
export const employmentStatusEnum = pgEnum(
  "employment_status_enum",
  employmentStatusEnumSchema.enum,
);

// Unemployment Compensation Status Enum
export const unemploymentCompensationStatusEnumSchema = z.enum([
  "UNEMPLOYMENT_COMPENSATED",
  "NOT_UNEMPLOYMENT_COMPENSATED",
]);
export type UnemploymentCompensationStatusEnumType = z.infer<
  typeof unemploymentCompensationStatusEnumSchema
>;
export const unemploymentCompensationStatusEnum = pgEnum(
  "unemployment_compensation_status_enum",
  unemploymentCompensationStatusEnumSchema.enum,
);

// Pay Frequency Enum
export const payFrequencyEnumSchema = z.enum([
  "WEEKLY",
  "BI_WEEKLY",
  "MONTHLY",
  "ANNUALLY",
]);
export type PayFrequencyEnumType = z.infer<typeof payFrequencyEnumSchema>;
export const payFrequencyEnum = pgEnum(
  "pay_frequency_enum",
  payFrequencyEnumSchema.enum,
);

// Age Range Enum - Baby, Child, Youth, Young Adult, Adult, Turning Senior, Senior
export const ageRangeEnumSchema = z.enum([
  "BABY",
  "CHILD",
  "YOUTH",
  "YOUNG_ADULT",
  "ADULT",
  "TURNING_SENIOR",
  "SENIOR",
]);
export type AgeRangeEnumType = z.infer<typeof ageRangeEnumSchema>;
export const ageRangeEnum = pgEnum("age_range_enum", ageRangeEnumSchema.enum);
